import { createFileRoute } from '@tanstack/react-router'

import { AdminHome } from '@/pages/home/admin-home'

export const Route = createFileRoute('/_layout/')({
  component: AdminHome,
})
